const DISCOUNT = 0.9
export default DISCOUNT